import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { CategoryDTO, CategoryKind } from '@shared/types';

export function useCategories(kind?: CategoryKind) {
  return useQuery({
    queryKey: ['categories', kind],
    queryFn: async () => (await api.get<CategoryDTO[]>('/categories', { params: { kind } })).data,
  });
}

export function useCreateCategory() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: { kind: CategoryKind; name: string; color?: string | null }) =>
      (await api.post<CategoryDTO>('/categories', input)).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['categories'] }),
  });
}

export function useArchiveCategory() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: number) => api.delete(`/categories/${id}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['categories'] }),
  });
}
